/**
 * DataTableRow class
 *
 * @package    DataTable
 * @author     Maxim Lukianenko <mlukianenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';

import { get } from 'Utils';
import DataTableCell from './DataTableCell';
import { DataTableColumnType, DataTableItemType } from 'Types';

export default class DataTableRow extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        columns: PropTypes.arrayOf(DataTableColumnType).isRequired,
        item: DataTableItemType.isRequired,
        onRowClick: PropTypes.func,
        customClassName: PropTypes.string,
    };

    handleRowClick = () => {
        const { item, onRowClick } = this.props;
        onRowClick && onRowClick(item);
    };

    render() {
        const { columns, item, customClassName } = this.props;

        return (
            <TableRow onClick={this.handleRowClick} className={customClassName}>
                {columns.map(column => (
                    <DataTableCell key={column.key} column={column} value={get(item, column.key)} item={item} />
                ))}
            </TableRow>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableBody/DataTableRow.jsx